// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-width: 600px)and (max-width: 959px){.v-responsive[data-v-5e006694]{max-width:740px;margin:0 auto}}\n.virtual-tour-video[data-v-5e006694]{position:absolute;width:auto;height:100%;overflow:hidden;pointer-events:none;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}", ""]);
// Exports
module.exports = exports;
